/* eslint-disable */
// @ts-nocheck
/**
 * @fileoverview gRPC-Web generated client stub for worklayer.internal.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.19.1
// source: internal/info_gathering.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_api_field_behavior_pb = require('../google/api/field_behavior_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')

var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js')
const proto = {};
proto.worklayer = {};
proto.worklayer.internal = {};
proto.worklayer.internal.v1 = require('./info_gathering_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.worklayer.internal.v1.InfoGatheringServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.worklayer.internal.v1.InfoGatheringServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.GetChecklistRequest,
 *   !proto.worklayer.internal.v1.Checklist>}
 */
const methodDescriptor_InfoGatheringService_GetChecklist = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.InfoGatheringService/GetChecklist',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.GetChecklistRequest,
  proto.worklayer.internal.v1.Checklist,
  /**
   * @param {!proto.worklayer.internal.v1.GetChecklistRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.Checklist.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.GetChecklistRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.Checklist)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.Checklist>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.InfoGatheringServiceClient.prototype.getChecklist =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.InfoGatheringService/GetChecklist',
      request,
      metadata || {},
      methodDescriptor_InfoGatheringService_GetChecklist,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.GetChecklistRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.Checklist>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.InfoGatheringServicePromiseClient.prototype.getChecklist =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.InfoGatheringService/GetChecklist',
      request,
      metadata || {},
      methodDescriptor_InfoGatheringService_GetChecklist);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.ProvideSupportingItemDocumentRequest,
 *   !proto.worklayer.internal.v1.ProvideSupportingItemDocumentResponse>}
 */
const methodDescriptor_InfoGatheringService_ProvideSupportingItemDocument = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.InfoGatheringService/ProvideSupportingItemDocument',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.ProvideSupportingItemDocumentRequest,
  proto.worklayer.internal.v1.ProvideSupportingItemDocumentResponse,
  /**
   * @param {!proto.worklayer.internal.v1.ProvideSupportingItemDocumentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.ProvideSupportingItemDocumentResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemDocumentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.ProvideSupportingItemDocumentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.ProvideSupportingItemDocumentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.InfoGatheringServiceClient.prototype.provideSupportingItemDocument =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.InfoGatheringService/ProvideSupportingItemDocument',
      request,
      metadata || {},
      methodDescriptor_InfoGatheringService_ProvideSupportingItemDocument,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemDocumentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.ProvideSupportingItemDocumentResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.InfoGatheringServicePromiseClient.prototype.provideSupportingItemDocument =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.InfoGatheringService/ProvideSupportingItemDocument',
      request,
      metadata || {},
      methodDescriptor_InfoGatheringService_ProvideSupportingItemDocument);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.RemoveSupportingItemDocumentRequest,
 *   !proto.worklayer.internal.v1.RemoveSupportingItemDocumentResponse>}
 */
const methodDescriptor_InfoGatheringService_RemoveSupportingItemDocument = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.InfoGatheringService/RemoveSupportingItemDocument',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.RemoveSupportingItemDocumentRequest,
  proto.worklayer.internal.v1.RemoveSupportingItemDocumentResponse,
  /**
   * @param {!proto.worklayer.internal.v1.RemoveSupportingItemDocumentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.RemoveSupportingItemDocumentResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.RemoveSupportingItemDocumentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.RemoveSupportingItemDocumentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.RemoveSupportingItemDocumentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.InfoGatheringServiceClient.prototype.removeSupportingItemDocument =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.InfoGatheringService/RemoveSupportingItemDocument',
      request,
      metadata || {},
      methodDescriptor_InfoGatheringService_RemoveSupportingItemDocument,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.RemoveSupportingItemDocumentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.RemoveSupportingItemDocumentResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.InfoGatheringServicePromiseClient.prototype.removeSupportingItemDocument =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.InfoGatheringService/RemoveSupportingItemDocument',
      request,
      metadata || {},
      methodDescriptor_InfoGatheringService_RemoveSupportingItemDocument);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoRequest,
 *   !proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoResponse>}
 */
const methodDescriptor_InfoGatheringService_ProvideSupportingItemPersonalInfo = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.InfoGatheringService/ProvideSupportingItemPersonalInfo',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoRequest,
  proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoResponse,
  /**
   * @param {!proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.InfoGatheringServiceClient.prototype.provideSupportingItemPersonalInfo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.InfoGatheringService/ProvideSupportingItemPersonalInfo',
      request,
      metadata || {},
      methodDescriptor_InfoGatheringService_ProvideSupportingItemPersonalInfo,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.InfoGatheringServicePromiseClient.prototype.provideSupportingItemPersonalInfo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.InfoGatheringService/ProvideSupportingItemPersonalInfo',
      request,
      metadata || {},
      methodDescriptor_InfoGatheringService_ProvideSupportingItemPersonalInfo);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoRequest,
 *   !proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoResponse>}
 */
const methodDescriptor_InfoGatheringService_ProvideSupportingItemDependentInfo = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.InfoGatheringService/ProvideSupportingItemDependentInfo',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoRequest,
  proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoResponse,
  /**
   * @param {!proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.InfoGatheringServiceClient.prototype.provideSupportingItemDependentInfo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.InfoGatheringService/ProvideSupportingItemDependentInfo',
      request,
      metadata || {},
      methodDescriptor_InfoGatheringService_ProvideSupportingItemDependentInfo,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.InfoGatheringServicePromiseClient.prototype.provideSupportingItemDependentInfo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.InfoGatheringService/ProvideSupportingItemDependentInfo',
      request,
      metadata || {},
      methodDescriptor_InfoGatheringService_ProvideSupportingItemDependentInfo);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoRequest,
 *   !proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoResponse>}
 */
const methodDescriptor_InfoGatheringService_RemoveSupportingItemDependentInfo = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.InfoGatheringService/RemoveSupportingItemDependentInfo',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoRequest,
  proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoResponse,
  /**
   * @param {!proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.InfoGatheringServiceClient.prototype.removeSupportingItemDependentInfo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.InfoGatheringService/RemoveSupportingItemDependentInfo',
      request,
      metadata || {},
      methodDescriptor_InfoGatheringService_RemoveSupportingItemDependentInfo,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.InfoGatheringServicePromiseClient.prototype.removeSupportingItemDependentInfo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.InfoGatheringService/RemoveSupportingItemDependentInfo',
      request,
      metadata || {},
      methodDescriptor_InfoGatheringService_RemoveSupportingItemDependentInfo);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoRequest,
 *   !proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoResponse>}
 */
const methodDescriptor_InfoGatheringService_ProvideSupportingItemSpousalInfo = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.InfoGatheringService/ProvideSupportingItemSpousalInfo',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoRequest,
  proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoResponse,
  /**
   * @param {!proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.InfoGatheringServiceClient.prototype.provideSupportingItemSpousalInfo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.InfoGatheringService/ProvideSupportingItemSpousalInfo',
      request,
      metadata || {},
      methodDescriptor_InfoGatheringService_ProvideSupportingItemSpousalInfo,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.InfoGatheringServicePromiseClient.prototype.provideSupportingItemSpousalInfo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.InfoGatheringService/ProvideSupportingItemSpousalInfo',
      request,
      metadata || {},
      methodDescriptor_InfoGatheringService_ProvideSupportingItemSpousalInfo);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodRequest,
 *   !proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodResponse>}
 */
const methodDescriptor_InfoGatheringService_ProvideSupportingItemPersonalRefundMethod = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.InfoGatheringService/ProvideSupportingItemPersonalRefundMethod',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodRequest,
  proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodResponse,
  /**
   * @param {!proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.InfoGatheringServiceClient.prototype.provideSupportingItemPersonalRefundMethod =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.InfoGatheringService/ProvideSupportingItemPersonalRefundMethod',
      request,
      metadata || {},
      methodDescriptor_InfoGatheringService_ProvideSupportingItemPersonalRefundMethod,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.InfoGatheringServicePromiseClient.prototype.provideSupportingItemPersonalRefundMethod =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.InfoGatheringService/ProvideSupportingItemPersonalRefundMethod',
      request,
      metadata || {},
      methodDescriptor_InfoGatheringService_ProvideSupportingItemPersonalRefundMethod);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoRequest,
 *   !proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoResponse>}
 */
const methodDescriptor_InfoGatheringService_ProvideSupportingItemBusinessInfo = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.InfoGatheringService/ProvideSupportingItemBusinessInfo',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoRequest,
  proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoResponse,
  /**
   * @param {!proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.InfoGatheringServiceClient.prototype.provideSupportingItemBusinessInfo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.InfoGatheringService/ProvideSupportingItemBusinessInfo',
      request,
      metadata || {},
      methodDescriptor_InfoGatheringService_ProvideSupportingItemBusinessInfo,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.InfoGatheringServicePromiseClient.prototype.provideSupportingItemBusinessInfo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.InfoGatheringService/ProvideSupportingItemBusinessInfo',
      request,
      metadata || {},
      methodDescriptor_InfoGatheringService_ProvideSupportingItemBusinessInfo);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.ProvideSupportingItemNotesRequest,
 *   !proto.worklayer.internal.v1.ProvideSupportingItemNotesResponse>}
 */
const methodDescriptor_InfoGatheringService_ProvideSupportingItemNotes = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.InfoGatheringService/ProvideSupportingItemNotes',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.ProvideSupportingItemNotesRequest,
  proto.worklayer.internal.v1.ProvideSupportingItemNotesResponse,
  /**
   * @param {!proto.worklayer.internal.v1.ProvideSupportingItemNotesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.ProvideSupportingItemNotesResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemNotesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.ProvideSupportingItemNotesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.ProvideSupportingItemNotesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.InfoGatheringServiceClient.prototype.provideSupportingItemNotes =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.InfoGatheringService/ProvideSupportingItemNotes',
      request,
      metadata || {},
      methodDescriptor_InfoGatheringService_ProvideSupportingItemNotes,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemNotesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.ProvideSupportingItemNotesResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.InfoGatheringServicePromiseClient.prototype.provideSupportingItemNotes =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.InfoGatheringService/ProvideSupportingItemNotes',
      request,
      metadata || {},
      methodDescriptor_InfoGatheringService_ProvideSupportingItemNotes);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodRequest,
 *   !proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodResponse>}
 */
const methodDescriptor_InfoGatheringService_ProvideSupportingItemBusinessRefundMethod = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.InfoGatheringService/ProvideSupportingItemBusinessRefundMethod',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodRequest,
  proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodResponse,
  /**
   * @param {!proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.InfoGatheringServiceClient.prototype.provideSupportingItemBusinessRefundMethod =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.InfoGatheringService/ProvideSupportingItemBusinessRefundMethod',
      request,
      metadata || {},
      methodDescriptor_InfoGatheringService_ProvideSupportingItemBusinessRefundMethod,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.InfoGatheringServicePromiseClient.prototype.provideSupportingItemBusinessRefundMethod =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.InfoGatheringService/ProvideSupportingItemBusinessRefundMethod',
      request,
      metadata || {},
      methodDescriptor_InfoGatheringService_ProvideSupportingItemBusinessRefundMethod);
};


module.exports = proto.worklayer.internal.v1;

